<script setup>
import SYearMonthSelector from '@/components/global/inputs/s-year-month-selector.vue'
import UsagerAutocomplete from '@/components/usager/usager-autocomplete.vue'
</script>

<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col align-self="center" class="pa-0">
        <usager-autocomplete
          ref="usagerSelectorFicheAim"
          class="pt-0 mt-0"
          v-model="usager"
          label="Usager"
          required
          hide-details
          dense
          @input="handleChangeUsager"
        />
      </v-col>
      <v-col align-self="center" class="pa-0">
        <s-year-month-selector
          class="pt-1"
          ref="yearMonthSelectorFicheAim"
          :init-annee="ficheActuelle.annee"
          :init-mois="ficheActuelle.mois"
          :next-icon="nextIcon"
          :disable-prev="!existeFichePrecedanteEtSuivante.existePrecedante"
          :disable-next="!existeFichePrecedanteEtSuivante.existeSuivante && !estFicheSuivanteACreer"
          @prev="allerALaFichePrecedante"
          @next="allerALaFicheSuivante"
        />
      </v-col>
    </v-row>
    <v-snackbar v-model="showCantFindFicheErrorMessage" timeout="5000">
      {{ errorMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="showCantFindFicheErrorMessage = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'selecteur-fiche-aim',
  data() {
    return {
      mois: undefined,
      annee: undefined,
      usager: undefined,
      errorMessage: undefined,
      showCantFindFicheErrorMessage: false,
    }
  },
  props: {
    ficheActuelle: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      existeFichePrecedanteEtSuivante: 'ficheAIM/getExisteFichePrecedanteEtSuivante',
      selectedEtablissement: 'application/getSelectedEtablissement',
    }),
    estFicheSuivanteACreer() {
      return this.ficheActuelle.statut === 'VALIDEE' && !this.existeFichePrecedanteEtSuivante.existeSuivante
    },
    nextIcon() {
      return this.existeFichePrecedanteEtSuivante.existeSuivante ? 'mdi-chevron-right' : 'mdi-plus'
    },
  },
  watch: {
    ficheActuelle(newFiche) {
      this.fetchExisteFichesAdjacentes(newFiche.ficheAIMId)
    },
  },
  methods: {
    ...mapActions({
      fetchFicheAimByUsagerIdAndMoisAndAnnee: 'ficheAIM/fetchFicheAimByUsagerIdAndMoisAndAnnee',
      fetchExisteFichesAdjacentes: 'ficheAIM/existeFichesAdjacentes',
      initializerLaFicheAIMSuivante: 'ficheAIM/initializerLaFicheAIMSuivante',
    }),
    updateMoisAnnee({ mois, annee }) {
      this.mois = mois
      this.annee = annee
    },
    handleChangeUsager(usager) {
      this.usager = usager
      this.changerDeFiche()
    },
    allerALaFichePrecedante(moisAnnee) {
      this.updateMoisAnnee(moisAnnee)
      this.changerDeFiche()
    },
    async allerALaFicheSuivante(moisAnnee) {
      this.updateMoisAnnee(moisAnnee)
      if (this.estFicheSuivanteACreer) {
        await this.creerFicheSuivante()
        this.changerDeFiche()
      } else {
        this.changerDeFiche()
      }
    },
    creerFicheSuivante() {
      return this.initializerLaFicheAIMSuivante({
        etablissementId: this.selectedEtablissement.etablissementId,
        usagerId: this.ficheActuelle.usager.usagerId,
      })
    },
    changerDeFiche() {
      this.fetchFicheAimByUsagerIdAndMoisAndAnnee({
        _usagerId: this.usager.usagerId,
        _mois: this.mois,
        _annee: this.annee,
      }).then((value) => {
        if (value == null) this.onError()
        else {
          this.$router.push({ name: 'fiche-aim', params: { ficheAimId: value.ficheAIMId } })
        }
      })
    },

    onError() {
      this.errorMessage =
        'Impossible de charger la fiche de ' +
        this.usager.etatCivil.nomComplet.nom +
        ' ' +
        this.usager.etatCivil.nomComplet.prenom +
        ' pour le ' +
        this.mois +
        '/' +
        this.annee +
        ". Assurez-vous qu'elle a bien été créée et réessayez plus tard"
      this.$refs.yearMonthSelectorFicheAim.reset()
      this.$refs.usagerSelectorFicheAim.reset(this.ficheActuelle.usager)
      this.showCantFindFicheErrorMessage = true
    },
  },
  created() {
    this.mois = this.ficheActuelle.mois
    this.annee = this.ficheActuelle.annee
    this.usager = this.ficheActuelle.usager
    this.fetchExisteFichesAdjacentes(this.ficheActuelle.ficheAIMId)
  },
}
</script>

<style>
.v-select__selections {
  font-size: 14px !important;
}
</style>
